/*-------------------------------------------------------------------------------

  フォーム初回読み込み

--------------------------------------------------------------------------------*/
export default class tccf7Load {
  
  /**
   * @param {HTMLElement} form - 対象となるフォームラッパー要素
   */
  constructor(form) {
    this.form = form;
    if( !this.form ) return;

    this.boundEnterCancel = this.enterCancelHandler.bind(this);
    this.init();
  }

  /*----------------------------------------
    初期化
  ------------------------------------------*/
  init() {
    this.setEnterCancel();
  }

  /*----------------------------------------
    Enterキー：誤送信防止イベント設定
  ------------------------------------------*/
  setEnterCancel() {
    this.form.addEventListener('keydown', this.boundEnterCancel);
  }

  /*----------------------------------------
    Enterキー：誤送信防止イベント内容
  ------------------------------------------*/
  /**
   * @param {KeyboardEvent} event 
   */
  enterCancelHandler(event) {
    if (event.isComposing) return;

    if (event.key === 'Enter') {
      const target = event.target;
      if (target.tagName === 'TEXTAREA') return;
      if (target.closest('.wpcf7-form')) {
        event.preventDefault();
        return false;
      }
    }
  }

  /*----------------------------------------
    Enterキー：誤送信防止イベント削除
  ------------------------------------------*/
  destroy() {
    this.form.removeEventListener('keydown', this.boundEnterCancel);
  }
}
